import { ROOM_SIZE_NAMES } from 'Globals/Constants'

export const clamp = (num: number, min: number, max: number) =>
  Math.min(Math.max(num, min), max)

export const formatNumber = (number: number | string) => {
  return +number > 10_000
    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
    : number
}
export const formatPercent = (number: number | string) => {

  if (+number <= 0.01) return '<0.01%'
  return ('' + (+number).toFixed(2)).replace('.', ',') + '%'
}
export const roomSizeStringFormatter = (roomSize: string) =>
  roomSize.replace('Zi_', '').replace('-', '–').replace('.', ',')

export const roomSizeNumberToStringConverter = (size: number) =>
  roomSizeStringFormatter(ROOM_SIZE_NAMES[size])

export function replaceAll(str: string, search: string, replacement: string) {
  var target = str
  return target.split(search).join(replacement)
}

const swiss_population_2021 = 8740000
const swiss_population_2022 = 8740472

export const percentOfPopulation = (count: number) => {
  const val = +((count / swiss_population_2022) * 100).toFixed(2)
  if (val < 0.01) return '< 0,01%'
  return (val+"").replace(".",",") + '%'
}
